import { NavLink, useLocation } from 'react-router-dom';
import './SubNavigation.scss';
import { useTranslation } from 'react-i18next';
import { getEnvironmentUrl } from '@utils/environmentUtils';
// import { useState } from 'react';
// import {
//   ButtonFlavor, ButtonSize, ButtonType, ExDropdown, ExMenu, ExMenuItem,
// } from '@boomi/exosphere';

export default function SubNavigation() {
  const location = useLocation();
  // const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isAgentGardenActive = location.pathname === '/home'
    || location.pathname === '/chat'
    || location.pathname === '/agent-designer'
    || location.pathname === '/agents'
    || location.pathname === '/tools'
    || location.pathname === '/sources'
    || location.pathname === '/add-tools'
    || location.pathname === '/add-source'
    || location.pathname === '/add-acp-source';
  const isAgentRegistryActive = location.pathname === '/agentRegistry';
  // const toggleMenu = () => {
  //   setIsMenuOpen(!isMenuOpen);
  // };

  const getRegistryUrl = (event: any) => {
    event.preventDefault(); // Prevent default NavLink behavior
    window.location.href = getEnvironmentUrl(); // Redirect to the registry URL
  };
  const [t] = useTranslation('common');
  return (
    <header className="header">
      <div className="header-title">
        {t('agent_studio')}
        <span className="header-divider">|</span>
      </div>
      {/* <div className="burger-menu">
        <ExDropdown
          icon="Menu"
          text=""
          flavor={ButtonFlavor.BRANDED}
          className="step-dropdown-button"
          type={ButtonType.TERTIARY}
          align="left"
          onClick={toggleMenu}
          size={ButtonSize.SMALL}
        >
          <ExMenu className="step-select-dropdown">
            <ExMenuItem
              value="Agent Control Center"
            >
              Agent Control Center
            </ExMenuItem>
          </ExMenu>
        </ExDropdown>
      </div> */}
      {/* <nav className="mini-header-nav">
        {isAgentGardenActive && (
        <div className="active-nav-menu">
          <NavLink
            to="/home"
            className={() => (isAgentGardenActive ? 'nav-link active' : 'nav-link')}
            data-testid="subnav-agent-garden-nav-link"
          >
            Agent Garden
          </NavLink>
          <NavLink
            to="#"
            onClick={(e: any) => getRegistryUrl(e)}
            className={() => (isAgentRegistryActive ? 'nav-link active' : 'nav-link')}
            data-testid="subnav-agent-control-tower-nav-link"
          >
            Agent Control Tower
          </NavLink>
        </div>
        )}
      </nav> */}
      <nav className="header-nav">
        <NavLink
          to="/home"
          className={() => (isAgentGardenActive ? 'nav-link active' : 'nav-link')}
          data-testid="subnav-agent-garden-nav-link"
        >
          {t('agent_garden')}
        </NavLink>
        <NavLink
          to="#"
          onClick={(e: any) => getRegistryUrl(e)}
          className={() => (isAgentRegistryActive ? 'nav-link active' : 'nav-link')}
          data-testid="subnav-agent-control-tower-nav-link"
        >
          {t('agent_control_tower')}
        </NavLink>

      </nav>
    </header>
  );
}
